import {
  BackgroundMusic,
  CreateBackgroundMusic,
  GetListResponse,
} from "@app/types";
import HttpService from "@core/services/http/http.service";
import {
  RequestContentType,
  RequestParams,
  Signal,
} from "@core/services/http/http.type";

class _BackgroundMusicService {
  public getList(
    requestParams?: RequestParams,
    signal?: Signal,
    isShowLoading?: boolean
  ) {
    return HttpService.get<GetListResponse<BackgroundMusic>>(
      "/admin/api/v1/background-musics",
      {
        queryParams: { ...requestParams },
        signal,
        isShowLoading,
      }
    );
  }

  public create(createBackgroundMusic: CreateBackgroundMusic) {
    return HttpService.post("/admin/api/v1/background-musics", {
      body: { ...createBackgroundMusic },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public update(
    backgroundMusicId: number,
    createBackgroundMusic: CreateBackgroundMusic
  ) {
    return HttpService.patch(
      `/admin/api/v1/background-musics/${backgroundMusicId}`,
      {
        body: { ...createBackgroundMusic },
        requestContentType: RequestContentType.MULTIPART,
      }
    );
  }

  public delete(backgroundMusicId: number) {
    return HttpService.delete(
      `/admin/api/v1/background-musics/${backgroundMusicId}`
    );
  }
}

const BackgroundMusicService = new _BackgroundMusicService();

export default BackgroundMusicService;
